import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";
import { toast } from "sonner";

const WishlistCtx = createContext(null);
export const useWishlist = () => useContext(WishlistCtx);

export function WishlistProvider({ children }) {
  const { user, login } = useAuth();
  const [ids, setIds] = useState([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) { setIds([]); return; }
    try {
      const r = await api.get("/wishlist");
      setIds(r.data || []);
    } catch { setIds([]); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const has = (pid) => ids.includes(pid);

  const toggle = async (pid) => {
    if (!user) {
      toast.message("Sign in to save favorites", {
        action: { label: "Sign in", onClick: login }
      });
      return;
    }
    setLoading(true);
    try {
      const r = await api.post("/wishlist/toggle", { product_id: pid });
      setIds(r.data.product_ids || []);
      toast.success(r.data.added ? "Saved to wishlist" : "Removed from wishlist");
    } catch (e) {
      toast.error("Could not update wishlist");
    } finally { setLoading(false); }
  };

  return (
    <WishlistCtx.Provider value={{ ids, has, toggle, loading, refresh, count: ids.length }}>
      {children}
    </WishlistCtx.Provider>
  );
}
